import PriceSearch from '../../components/layout/stores/PriceSearch';
import '../../assets/css/pages/stores/price-search.css';
import { useLocation } from 'react-router-dom';

const PriceRegistrationPage = () => {
    const search = useLocation().search;
    const query = new URLSearchParams(search);
    const paramCompetitorStoreCode = query.get('competitorStoreCode');

    return (
        <div className="price-registration">
            <PriceSearch paramCompetitorStoreCode={paramCompetitorStoreCode} />
        </div>
    );
};

export default PriceRegistrationPage;
